import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommercePerformanceReportOrdersEntityState} from "../reducers/ecommerce-performance-report-order.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommercePerformanceReportOrdersState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommercePerformanceReportOrders.entities[websiteId]);

export const getEcommercePerformanceReportOrders = (websiteId: number) => createSelector(getEcommercePerformanceReportOrdersState(websiteId),
  (state: IEcommercePerformanceReportOrdersEntityState) => {
      return state.ordersData;
  }
);

export const getEcommercePerformanceReportOrdersLoading = (websiteId: number) => createSelector(getEcommercePerformanceReportOrdersState(websiteId),
  (state: IEcommercePerformanceReportOrdersEntityState) => state && state.loading
);

export const getEcommercePerformanceReportOrdersLoaded = (websiteId: number) => createSelector(getEcommercePerformanceReportOrdersState(websiteId),
  (state: IEcommercePerformanceReportOrdersEntityState) => state && state.loaded
);
